import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getSessionId } from '../utils/session';

const ProgressContext = createContext();

export const useProgress = () => useContext(ProgressContext);

export const ProgressProvider = ({ children }) => {
  const { user } = useAuth();
  const [credits, setCredits] = useState(0);
  const [modulesCompleted, setModulesCompleted] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dataReady, setDataReady] = useState(false);

  const fetchProgress = async () => {
    try {
      setLoading(true);
      setDataReady(false);
      const token = localStorage.getItem('token');
      const sessionId = getSessionId();

      console.log('🔍 fetchProgress called:', { token: !!token, sessionId });

      // If logged in, fetch from user account
      if (token) {
        console.log('🔍 Fetching for registered user');
        const response = await fetch('/api/credits/balances', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          const total = data.reduce((sum, b) => sum + b.balance, 0);
          setCredits(total);
        }

        const modulesRes = await fetch('/api/education/progress/all', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (modulesRes.ok) {
          const modulesData = await modulesRes.json();
          const completed = modulesData.filter(p => p.completed).length;
          setModulesCompleted(completed);
        }
      } 
      // If curious+ with session, fetch from session
      else if (sessionId) {
        console.log('🔍 Fetching for Curious+ user, sessionId:', sessionId);
        const response = await fetch(`/api/session/status?sessionId=${sessionId}`);
        if (response.ok) {
          const data = await response.json();
          console.log('🔍 Session data:', data);
          const totalCredits = data.pendingCredits?.reduce((sum, c) => sum + c.amount, 0) || 0;
          setCredits(totalCredits);
          setModulesCompleted(data.modulesCompleted || 0);
          console.log('🔍 Credits set:', totalCredits, 'Modules:', data.modulesCompleted);
        }
      } else {
        console.log('🔍 No token or sessionId found');
      }
      
      setDataReady(true);
    } catch (error) {
      console.error('Error fetching progress:', error);
      setDataReady(true);
    } finally {
      setLoading(false);
    }
  };

  const updateProgress = (data) => {
    if (data.credits !== undefined) setCredits(data.credits);
    if (data.modulesCompleted !== undefined) setModulesCompleted(data.modulesCompleted);
  };

  useEffect(() => {
    fetchProgress();
  }, [user]);

  return (
    <ProgressContext.Provider value={{
      credits,
      modulesCompleted,
      loading,
      dataReady,
      fetchProgress,
      updateProgress
    }}>
      {children}
    </ProgressContext.Provider>
  );
};
